export const gameList = [
  {
    id: "game-1",
    title: "《星域征途》新手开局全攻略：前二十级高效养成路线",
    gameType: "开放世界",
    platform: "PC",
    tags: ["新手向", "养成", "开放世界"],
    author: "攻略组·北辰",
    date: "2026-10-14",
    cover:
      "https://readdy.ai/api/search-image?query=futuristic%20open%20world%20game%20landscape%20with%20glowing%20crystals%20and%20floating%20islands%2C%20epic%20purple%20and%20orange%20sky%2C%20adventure%20game%20concept%20art%2C%20highly%20detailed&width=800&height=450&seq=game-starfield-guide-01&orientation=landscape",
    summary:
      "从角色创建到前二十级的资源规划，这份攻略整理了当前版本最高效的开局路线，帮你少走弯路，快速建立战力和资源上的优势。",
    content: [
      "《星域征途》的世界观相当庞大，新手最容易犯的错误就是盲目探索。建议在完成主线第二章之后，先集中清理出生点周边的支线任务，这些任务提供的经验与初始装备足够你平稳度过前期。",
      "资源分配方面，前二十级不建议大量强化低级装备，把材料留给第十级左右获得的蓝色品质武器性价比更高。体力药水请留到开放副本之后再使用。",
      "技能加点推荐优先提升主输出技能，辅助类技能保持一级即可。如果你的角色偏向远程，务必优先点出位移技能，这在应对精英怪时非常关键。",
      "最后提醒一点，开放世界中的传送点一定要尽早全部点亮。虽然会花上一些时间，但后续无论是做任务还是采集资源，都能节省大量跑图时间。",
    ],
  },
  {
    id: "game-2",
    title: "《暗影特勤》精准枪法训练指南：从压枪到预瞄的完整思路",
    gameType: "射击",
    platform: "PC",
    tags: ["枪法", "进阶", "竞技"],
    author: "战术板·老K",
    date: "2026-10-13",
    cover:
      "https://readdy.ai/api/search-image?query=tactical%20shooter%20game%20scene%20with%20a%20soldier%20aiming%20in%20a%20dusty%20urban%20environment%2C%20dramatic%20lighting%2C%20realistic%20military%20atmosphere%2C%20cinematic%20high%20detail&width=800&height=450&seq=game-shooter-aim-02&orientation=landscape",
    summary:
      "枪法不是天生的，而是一套可以刻意练习的方法。本文拆解压枪、预瞄、拉枪线三个核心环节，并给出适合每天的练习计划。",
    content: [
      "很多玩家把枪法差归咎于天赋，其实大部分情况下是练习方法不对。压枪的核心在于肌肉记忆，建议每天固定用靶场进行十到十五分钟的连续射击练习，重点感受不同距离下的后坐力节奏。",
      "预瞄是拉开水平差距的关键。养成移动时把准星保持在敌人可能出现的头部高度，可以大幅缩短遭遇战中的开火反应时间。练习时可以先从熟悉的地图点位开始。",
      "拉枪线不要追求一次性甩到目标，而是采用分段式微调。开火后如果第一梭没有击倒，应该立刻转移掩体，而不是原地对拼。",
      "最后建议每周回看一次自己的对局录像，重点分析被击杀的瞬间。找出重复出现的问题，比无脑排位更能提升实力。",
    ],
  },
  {
    id: "game-3",
    title: "《王者峡谷》新版本上分英雄推荐与对线细节",
    gameType: "MOBA",
    platform: "手机",
    tags: ["上分", "英雄推荐", "对线"],
    author: "战术板·小鹿",
    date: "2026-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20moba%20battle%20arena%20with%20glowing%20magic%20effects%20and%20a%20hero%20casting%20spells%2C%20vibrant%20orange%20and%20teal%20colors%2C%20dynamic%20action%20game%20art%2C%20highly%20detailed&width=800&height=450&seq=game-moba-hero-03&orientation=landscape",
    summary:
      "版本更新后，打野与中路的强度格局发生了明显变化。这份推荐结合当前胜率数据，给出各位置的上分选择与关键对线技巧。",
    content: [
      "本次版本调整主要加强了持续输出型英雄，同时削弱了部分爆发刺客。对于想要稳定上分的玩家，建议优先选择容错率高的英雄，而不是追逐操作上限极高的版本答案。",
      "打野位置上，具备强力开团能力的英雄在当前节奏下性价比最高。前期不要执着于单杀，帮助边路建立线上优势，往往能带来更大的雪球效应。",
      "中路对线要格外注意清线速度与支援时机。清完兵线后如果无事可做，应该主动前往河道查看视野，而不是站在原地等待下一波兵线。",
      "辅助玩家请记住，视野比人头更重要。在关键路口提前布下视野，能够有效避免全队被gank，也能为队伍的开团创造契机。",
    ],
  },
  {
    id: "game-4",
    title: "《王国余晖》全支线收集攻略：隐藏结局解锁条件详解",
    gameType: "角色扮演",
    platform: "PS5",
    tags: ["支线", "结局", "收集"],
    author: "攻略组·拾光",
    date: "2026-10-11",
    cover:
      "https://readdy.ai/api/search-image?query=majestic%20medieval%20fantasy%20castle%20at%20golden%20hour%20with%20banners%20and%20mountains%2C%20epic%20warm%20sunset%20lighting%2C%20cinematic%20rpg%20concept%20art%2C%20rich%20detail&width=800&height=450&seq=game-rpg-kingdom-04&orientation=landscape",
    summary:
      "本作共有四种结局，隐藏结局需要满足多个前置条件。这份攻略按章节顺序整理了全部支线触发点，确保你不会错过任何一个关键选择。",
    content: [
      "《王国余晖》的叙事魅力很大程度上来自支线任务，很多看似无关紧要的对话，其实都在为最终的隐藏结局埋下伏笔。建议在每一章结束前，都回头检查一遍支线列表是否清空。",
      "隐藏结局的解锁需要同时满足三个条件：完成全部同伴的忠诚支线、在关键剧情中选择保留王城、以及在最终战前收集齐六枚徽记。其中任意一项缺失都会导致进入普通结局。",
      "部分支线存在时间限制，一旦推进主线到下一章就会永久关闭。尤其是第二章的支线，建议在前往山脉之前全部处理完毕。",
      "最后，收集类支线虽然繁琐，但奖励的装备对最终战帮助很大。如果时间有限，至少保证把提供防具的支线完成，可以显著降低战斗难度。",
    ],
  },
  {
    id: "game-5",
    title: "《星际殖民地》资源运营思路：从零建立高效产能链",
    gameType: "策略",
    platform: "Switch",
    tags: ["运营", "策略", "新手向"],
    author: "攻略组·蓝图",
    date: "2026-10-10",
    cover:
      "https://readdy.ai/api/search-image?query=sci-fi%20space%20colony%20with%20domed%20habitats%20on%20an%20alien%20planet%20surface%2C%20glowing%20structures%2C%20orange%20desert%20landscape%2C%20detailed%20strategy%20game%20art&width=800&height=450&seq=game-strategy-colony-05&orientation=landscape",
    summary:
      "资源链的规划决定了殖民地能否长久运转。本文从电力、食物、材料三个维度出发，给出兼顾效率与稳定性的布局方案。",
    content: [
      "殖民地初期最容易被忽视的就是电力冗余。建议在建造任何新设施之前，预留至少百分之二十的电力储备，避免因为一次设备升级导致整个基地停摆。",
      "食物供应方面，优先发展可持续的种植设施，而不是依赖采集野生资源。前者虽然前期投入较大，但长期来看稳定得多，也能支撑更多人口。",
      "材料生产讲究就近原则。把采矿设施与加工设施放在同一区域，可以减少运输损耗，也能让物流路线更加清晰。",
      "中期扩张时，不要盲目追求设施数量。一条运转顺畅的产能链，远比一堆半停工的建筑更有价值。定期检查各设施的原料供给状态，及时补足瓶颈环节。",
    ],
  },
  {
    id: "game-6",
    title: "《刀锋旅人》Boss无伤打法：节拍闪避与反击时机",
    gameType: "动作",
    platform: "PC",
    tags: ["动作", "Boss", "高难"],
    author: "攻略组·北辰",
    date: "2026-10-09",
    cover:
      "https://readdy.ai/api/search-image?query=dark%20souls%20style%20action%20game%20with%20a%20lone%20warrior%20facing%20a%20giant%20monster%20in%20misty%20ruins%2C%20dramatic%20firelight%2C%20gritty%20epic%20atmosphere%2C%20high%20detail&width=800&height=450&seq=game-action-blade-06&orientation=landscape",
    summary:
      "这个Boss的攻击节奏极有规律，掌握好闪避节拍后就可以稳定无伤。本文逐招拆解动作前摇，并标出每一个可以反击的窗口。",
    content: [
      "面对这个Boss，硬拼血量几乎必输，关键在于读懂它的攻击节奏。它的连招大多以三段为一组，前两段速度较快，第三段会有明显的蓄力前摇，这就是最佳的反击窗口。",
      "闪避方向也有讲究。贴身时建议向Boss的侧后方翻滚，而不是直线后退。前者可以让你衔接反击，后者则容易被后续追击命中。",
      "二阶段它会增加一个范围砸地技能，地面会出现短暂的预警光圈。看到光圈后不要立刻翻滚，等光圈收缩到最小的一瞬间再动作，才能完美规避。",
      "全程保持耐心是通关的核心。哪怕已经打了半管血，也不要因为急躁而贸然上前贪刀，稳稳抓住自己熟悉的反击节奏，无伤通关只是时间问题。",
    ],
  },
  {
    id: "game-7",
    title: "《荒野纪元》前期资源快速积累：三天建成安全基地",
    gameType: "生存",
    platform: "PC",
    tags: ["生存", "建造", "效率"],
    author: "攻略组·拾光",
    date: "2026-10-08",
    cover:
      "https://readdy.ai/api/search-image?query=survival%20game%20scene%20with%20a%20wooden%20cabin%20in%20a%20forest%20during%20sunset%2C%20warm%20orange%20light%2C%20misty%20trees%2C%20atmospheric%20detailed%20game%20art&width=800&height=450&seq=game-survival-wild-07&orientation=landscape",
    summary:
      "第一天活下来、第三天站稳脚跟，是这份攻略的核心目标。本文给出最优采集顺序与基地选址思路，助你平稳度过最危险的前期。",
    content: [
      "开局第一件事不是造房子，而是找到水源。沿着河流建立临时据点，既能解决饮水问题，也方便后续运输木材与石料。",
      "采集顺序建议按照木材、石料、纤维的优先级进行。前三十分钟不要浪费时间去狩猎大型动物，用有限的体力换取基础建材更划算。",
      "基地选址要考虑三个要素：靠近水源、视野开阔、远离怪物刷新点。满足这三点的地形通常位于森林边缘与平原的交界处。",
      "夜晚是前期最危险的时候，务必在天黑前一小时回到据点，并点亮至少两个火把。黑暗中的怪物攻击力会显著提升，没有必要冒这个险。",
    ],
  },
  {
    id: "game-8",
    title: "《极速狂飙》赛道最佳路线：弯道刹车点与漂移技巧",
    gameType: "竞速",
    platform: "多平台",
    tags: ["竞速", "漂移", "技巧"],
    author: "攻略组·小鹿",
    date: "2026-10-07",
    cover:
      "https://readdy.ai/api/search-image?query=high%20speed%20racing%20car%20drifting%20on%20a%20mountain%20track%20with%20motion%20blur%20and%20sparks%2C%20vibrant%20orange%20and%20blue%20lighting%2C%20dynamic%20cinematic%20racing%20game%20art&width=800&height=450&seq=game-racing-speed-08&orientation=landscape",
    summary:
      "同一辆车、同样性能，圈速差距往往来自细节。本文针对三条经典赛道，逐一标注刹车点与漂移入弯路线，帮你稳定提升成绩。",
    content: [
      "想提升圈速，首先要改掉过早刹车的习惯。多数弯道的最佳刹车点其实比直觉更晚，建议先在练习模式里反复试探，找到车辆开始打滑前的临界点。",
      "漂移入弯的时机同样关键。入弯过早会导致出弯时车头偏离最佳路线，过晚则无法充分利用弯道宽度。理想状态是在弯心之前就开始轻微甩尾，让车身自然对准出弯方向。",
      "不同赛道的刹车点差异很大。山地赛道因为高度变化明显，下坡路段的刹车距离会比平地更短，需要提前减速。城市赛道则要更注意路肩的抓地力差异。",
      "最后提醒一点，轮胎温度对抓地力影响巨大。开局的暖胎圈不要浪费，用它把轮胎推到合适温度，正式计圈时才能跑出最佳成绩。",
    ],
  },
];